import { useSetAtom } from 'jotai';
import { focusAtom } from 'jotai-optics';
import { useTranslation } from 'react-i18next';

import { Button } from '@cfa/react-components';

import {
  trainTogetherModeAtom,
  trainTogetherModeDispatchAtom,
} from '@/atoms/trainTogetherMode';

const showTrainTogetherPopupAtom = focusAtom(trainTogetherModeAtom, o =>
  o.prop('showTrainTogetherPopup'),
);

const TrainTogetherModeExitButton = () => {
  const setShowTrainTogetherPopup = useSetAtom(showTrainTogetherPopupAtom);
  const sendTrainTogetherModeAction = useSetAtom(trainTogetherModeDispatchAtom);

  const { t } = useTranslation();

  const handleExit = () => {
    sendTrainTogetherModeAction('showProgressModal');
    setShowTrainTogetherPopup(false);
  };

  return (
    <div className="flex cursor-pointer items-center justify-between gap-4">
      <Button
        color="secondary"
        data-testid="ExitTrainTogetherModeButton"
        onClick={handleExit}
      >
        {t('Button.exitTrainTogether')}
      </Button>
    </div>
  );
};

export default TrainTogetherModeExitButton;
